var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoKanban(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "282.000000pt",
    height: "187.000000pt",
    viewBox: "0 0 282.000000 187.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,187.000000) scale(0.100000,-0.100000)",
    fill: "#043459",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1690 1692 l-326 -148 -39 29 c-52 39 -184 100 -265 123 -91 26 -318 26 -410 1 -152 -42 -344 -162 -432 -269 -89 -109 -155 -243 -185 -373 -22 -95 -21 -289 0 -378 73 -299 282 -526 572 -623 104 -34 300 -44 411 -21 155 33 304 112 414 219 30 29 255 280 501 558 l447 505 -49 50 c-27 28 -49 55 -49 61 0 5 27 36 60 69 l60 59 51 -49 50 -50 39 45 38 45 -50 57 c-27 32 -53 58 -56 58 -4 0 -34 -27 -67 -60 l-61 -60 -59 60 -59 60 -60 0 -60 0 49 -50 50 -50 -63 -62 -62 -63 -59 59 -58 58 -269 -294 c-148 -161 -379 -413 -513 -561 -144 -159 -251 -267 -261 -267 -16 0 -640 663 -640 680 0 3 6 14 13 23 11 16 38 6 311 -113 296 -129 299 -130 320 -112 12 11 138 117 281 238 622 523 823 694 815 694 -3 0 -151 -67 -330 -148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1968 487 l-166 -192 141 -143 142 -142 351 0 c193 0 354 3 358 7 6 7 -643 664 -654 662 -3 0 -80 -87 -172 -192z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKanban);
export default __webpack_public_path__ + "static/media/logo-kanban.2efe802124940070ed36c9f148ecea33.svg";
export { ForwardRef as ReactComponent };